export function anchorBase64Download(
  isApp,
  mimeType,
  fileNameWithExtension,
  fileData
) {
  console.log(`Iniciando download`);
  var a = document.createElement("a");
  
  a.download = fileNameWithExtension;
  a.href = `data:${mimeType};name:${fileNameWithExtension};base64,${fileData}`;
  
  a.setAttribute("target", "_blank");
  a.click();
}

export function anchorBase64DownloadWithAtob(mimeType = 'video/mp4', fileName, base64Data) {
  // Detecta se está rodando dentro do Flutter WebView
  // O Flutter registra o canal 'download_channel' via addJavaScriptChannel
  if (window.download_channel) {
    window.download_channel.postMessage(
      JSON.stringify({ mimeType, fileName, base64Data })
    );
    console.log(`Download de '${fileName}' enviado ao app nativo.`);
    return;
  }

  // Fallback para browser desktop: abordagem via Blob URL

  // 1. Converter Base64 para um Array de Bytes
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);

  // 2. Criar o Blob
  const blob = new Blob([byteArray], { type: mimeType });

  // 3. Criar URL temporário para o Blob
  const blobUrl = URL.createObjectURL(blob);

  // 4. Criar elemento âncora e simular clique
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = fileName;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();

  // 5. Limpeza
  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);

  console.log(`Download de '${fileName}' iniciado.`);
}
